import './playerView.css';

import { useRecoilValue } from 'recoil';
import { userConfigState } from '../../recoil/atoms/userConfigState';

import { translate } from '../../../common/language/translations';
import { CareerTable } from '../tables/careerTable/CareerTable';
import { ClubHistoryEntry } from './PlayerView';
import { careerTablePadding, careerTableStickyColumnWidth } from '../tables/careerTable/careerColumns';
import { careerTableDynamicColumnsWidth } from '../tables/careerTable/careerColumns';
import { useWindowSize } from '../../../common/hooks/WindowSize';
import { getNavigationWidth } from '../../utils/navigationUtils';
import { careerTableStaticColumnsWidth } from '../tables/careerTable/careerColumns';
import { selectedPlayerState } from '../../recoil/atoms/selectedPlayerState';


interface PlayerViewCareerProps {
  clubHistory: ClubHistoryEntry[] | undefined;
  nationalHistory: ClubHistoryEntry[] | undefined;
}

export const PlayerViewCareer: React.FC<PlayerViewCareerProps> = ({
  clubHistory,
  nationalHistory,
}) => {

  const selectedPlayer = useRecoilValue(selectedPlayerState);

  const userConfig = useRecoilValue(userConfigState);

  const isGoalkeeper =
    selectedPlayer?.playerOverview?.position_info.positions.some(position => position.position === 'GK') ||
    selectedPlayer?.playerOverview?.position_info.primary_positions.some(position => position === 'G');

  const { width } = useWindowSize();
  const tableWidth = width - 24 - getNavigationWidth(userConfig);
  const careerTableNonStickyWidth = tableWidth - careerTableStickyColumnWidth;
  const careerTableNonStickyMinWidth = careerTableStaticColumnsWidth + (!isGoalkeeper ? careerTableDynamicColumnsWidth : 0) + careerTablePadding;
  const widthUnit = Math.max(careerTableNonStickyWidth / careerTableNonStickyMinWidth, 1);


  const getFullNationalTableHeight = () => {
    const height = nationalHistory && nationalHistory.length > 0
      ? 32 + (nationalHistory.length * 37) + (widthUnit <= 1 ? 15 : 0)
      : 38;

    return height;
  };


  return (
    <div className='full-size-container'>
      <div className='player-view-widget-container player-view-career-national-entry' style={{ height: Math.min(300, getFullNationalTableHeight()) }}>

        {nationalHistory && nationalHistory.length === 0 && (
          <div className='player-view-career-entry-top-section'>
            <div className='player-view-career-entry-title'>
              {translate('noNationalCareer', userConfig?.language)}
            </div>
          </div>
        )}

        {nationalHistory && nationalHistory.length > 0 && (
          <CareerTable
            data={nationalHistory}
            isNationalTeam={true}
            isGoalkeeper={isGoalkeeper ?? false}
            widthUnit={widthUnit}
          />
        )}
      </div>

      <div className='player-view-widget-container player-view-career-club-entry' style={{ top: Math.min(300, getFullNationalTableHeight()) + 24 }}>
        {clubHistory && (
          <CareerTable
            data={clubHistory}
            isNationalTeam={false}
            isGoalkeeper={isGoalkeeper ?? false}
            widthUnit={widthUnit}
          />
        )}
      </div>
    </div>
  );
};
